export default __webpack_public_path__ + "static/media/admin_Info.3582e05c.svg";